module.exports = __webpack_public_path__ + "static/media/back-arrow.856e1c0a.svg";